import script from "./TransferRows.vue?vue&type=script&setup=true&lang=js"
export * from "./TransferRows.vue?vue&type=script&setup=true&lang=js"

import "./TransferRows.vue?vue&type=style&index=0&id=51128540&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51128540"]])

export default __exports__